import React from 'react'
import { ListingItem } from './ListingItem'
import { Listing, Color, Size, Condition } from '@/api'

interface ListingListProps {
  isSidebarOpen?: boolean
  listings: Listing[]
}

export const ListingList = ({
  isSidebarOpen = false,
  listings,
}: ListingListProps) => {
  const gridClasses = isSidebarOpen
    ? 'grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-1'
    : 'grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1'

  return (
    <div className="pb-4 sm:pb-6 md:pb-8 px-4 sm:px-5 md:px-6 bg-white">
      <div className={gridClasses}>
        {listings.map((listing) => (
          <ListingItem
            key={listing.id}
            uuid={listing.uuid}
            title={listing.product?.productMaster?.name || ''}
            listingPrice={listing.price || 0}
            originalPrice={listing.product?.productMaster?.price || undefined}
            image={listing.images?.[0]}
            images={listing.images || undefined}
            size={listing.size as Size}
            condition={listing.condition as Condition}
            color={listing.product?.color as Color}
            sex={listing.product?.productMaster?.sex}
          />
        ))}
      </div>
    </div>
  )
}
